module.exports = __webpack_public_path__ + "img/vulcano_dark_grey_ba_list.c67ed820.jpg";